<agr-form [formGroup]="formGroup()" class="margin-top">
  @for (question of questions(); track question.key; let i = $index) {
    <div class="form-row">
      <app-question-form
        [question]="question"
        [formGroup]="formGroup()"
        [readOnly]="readOnly()"
        (valueChanged)="handleValueChange($event)"
        data-test="tgaQuestionsForm"
      ></app-question-form>
    </div>
  }
</agr-form>
